<template>
	<JMessage :messages="computedMessages" @close="close">
		<template v-slot="{ content }">
			<!-- Content is a string -->
			<JBox v-if="content.type === 'message'">
				{{ content.text }}
			</JBox>

			<!-- The code here will contain every cases supported to show by CMessage -->
			<RouterLink v-else-if="content.type === 'link'" :to="content.to">
				{{ content.linkText }}
			</RouterLink>

			<JBox v-else-if="content.type === 'optimisticUIError'">
				<h4 class="">{{ content.title || "Error" }}</h4>
				<p v-if="content.errors && content.errors[0]">
					{{ typeof content.errors[0] === "object" ? content.errors[0].message : content.errors[0] }}
				</p>
			</JBox>
		</template>
	</JMessage>
</template>

<script>
/**
 * If you want to show a message just use this 
  	this.$store.dispatch("addToastMessage", {type: "neutral", content: "Information", cb: () => {}}) The cb will execute after that message close
  	this.$store.dispatch("addToastMessage", {type: "success", content: "Success"})
		this.$store.dispatch("addToastMessage", {type: "error", content: "Error"})
		this.$store.dispatch("addToastMessage", {type: "warning", content: "Warning"})

	* If you want to show a message with custom content (routerLink for example), you can do this
		this.$store.dispatch("addToastMessage", {type: "warning", content: {
			type: "link",
			to: { name: "ViewProductsHome" },
			linkText: "Click here to go home"
		}})
		Remember: you can put anything in the content object and use it in template v-slot, so it will allow you
			 to put any kind of components that you want to the CMessage
 */
export default {
	data() {
		return {
			activeMessage: false
		}
	},

	props: {
		max: {
			type: Number,
			default: 4
		}
	},

	computed: {
		computedMessages() {
			const messages = this.$store.state.messages ?? {}
			const messagesList = Object.keys(messages)?.map(key => ({
				...messages[key]
			}))

			return messagesList?.slice(Math.max(messagesList?.length - this?.max, 0), messagesList?.length) ?? []
		}
	},

	methods: {
		close(key) {
			this.$store.dispatch("removeToastMessage", key)
		}
	}
}
</script>
